export default "{\n    \"poweredBy\": \"Desarrollado por\"\n}\n"